import { render, staticRenderFns } from "./supplier-ledger.vue?vue&type=template&id=533c53ee&scoped=true&"
import script from "./supplier-ledger.vue?vue&type=script&lang=js&"
export * from "./supplier-ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c53ee",
  null
  
)

export default component.exports